import { create } from "zustand";
import { persist } from "zustand/middleware";

export type SidebarStoreState = {
  collapsed: boolean;
  toggleCollapsed: () => void;
};

export const useSidebarStore = create<SidebarStoreState>()(
  persist(
    (set) => {
      return {
        collapsed: false,

        toggleCollapsed: () => {
          set((state) => {
            return { collapsed: !state.collapsed };
          });
        },
      };
    },
    { name: "useSidebarStore" },
  ),
);
